
<div
    class="agpr-lightBox-overlay"
    [class.agpr-lightBox-overlay--modal]="modal"
    [ngStyle]="{'z-index': zIndex}"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <div
        [id]="id"
        class="agpr-lightBox"
    >
        <div class="agpr-lightBox-content">
            <ng-content></ng-content>
        </div>
        <button
            [id]="id + '.close'"
            class="agpr-lightBox-close"
            (click)="close.emit()"
            [agprTooltip]="'close' | localize"
        ><span class="fa fa-close"></span></button>
    </div>
</div>
